import { PickType } from '@nestjs/swagger';

import { RepairPaymentPaidDto } from './repair-payment-paid.dto';
import { RepairPaymentPaidCreatableInterface } from '../interfaces/repair-payment-paid-creatable.interface';

export class RepairPaymentPaidCreateDto
  extends PickType(RepairPaymentPaidDto, ['paid', 'repairPaymentId'])
  implements RepairPaymentPaidCreatableInterface {}
